import { useRef } from 'react';
import { Icon } from 'palette/Icon';
import { IColors, Thumbnail as ThumbnailObject } from 'palette/ProductCard/types/productData';
import { useProductCardContext } from '../ProductCardContext';
import Thumbnail from './Thumbnail';

import '../styles/Thumbnails.scss';

interface ThumbnailsProps {
    thumbs: ThumbnailObject[];
    colors: IColors;
}

const maxNumberOfThumbnails = 5;

function Thumbnails({
    thumbs = [],
    colors,
}: ThumbnailsProps) {
    const { isHovered, setActiveVariantId, setIsThumbnailsHovered } = useProductCardContext();
    const isLoadedOnce = useRef(false);

    const handleOnLoad = () => {
        if (!isLoadedOnce.current) {
            isLoadedOnce.current = true;
        }
    };

    const handleThumbnailsLeave = () => {
        setActiveVariantId(thumbs[0].variantId);
        setIsThumbnailsHovered(false);
    };

    return (
        <div
            className="palette-product-card-thumbnails"
            onMouseLeave={handleThumbnailsLeave}
        >
            {
                thumbs.slice(0, maxNumberOfThumbnails).map((thumb:ThumbnailObject, index) => {
                    const shouldRenderThumbnail = index === 0 || (isLoadedOnce.current || isHovered);
                    return shouldRenderThumbnail ? (
                        <Thumbnail
                            key={thumb.eanId}
                            color={colors.find(color => color.uniqueId === thumb.variantId) || null}
                            thumb={thumb}
                            onLoad={handleOnLoad}
                        />
                    ) : null;
                })
            }
            {
                thumbs.length > maxNumberOfThumbnails && (
                    <div className="palette-product-card-thumbnails__plus-sign">
                        <Icon
                            name="palette_plus"
                            size="x-small"
                        />
                    </div>
                )
            }
        </div>
    );
}

export default Thumbnails;
